import React from "react";
import "./Footer.css";
const LINKED_IN_LINK = "https://www.linkedin.com/company/djamma-dev";
const FACEBOOK_LINK = "https://www.facebook.com/djammadev";
const TWITTER_LINK = "https://x.com/djammadev";

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__main">
            <div className="footer__brand">
              <h3 className="footer__logo">🐔 Chiesugu</h3>
              <p className="footer__description">
                La première place de marché spécialisée dans la vente de
                produits avicoles au Mali. Connectons éleveurs et acheteurs pour
                un commerce transparent et sécurisé.
              </p>
              <div className="footer__social">
                <a
                  href={FACEBOOK_LINK}
                  target="_blank"
                  className="footer__social-link"
                >
                  📘
                </a>
                <a
                  href={TWITTER_LINK}
                  target="_blank"
                  className="footer__social-link"
                >
                  🐦
                </a>
                <a
                  href={LINKED_IN_LINK}
                  target="_blank"
                  className="footer__social-link"
                >
                  💼
                </a>
              </div>
            </div>

            <div className="footer__links">
              <div className="footer__column">
                <h4 className="footer__column-title">Application</h4>
                <ul className="footer__column-list">
                  <li>
                    <a href="#fonctionnalites" className="footer__column-link">
                      Fonctionnalités
                    </a>
                  </li>
                  <li>
                    <a href="#galerie" className="footer__column-link">
                      Galerie
                    </a>
                  </li>
                  <li>
                    <a href="#telecharger" className="footer__column-link">
                      Télécharger
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer__column">
                <h4 className="footer__column-title">Support</h4>
                <ul className="footer__column-list">
                  <li>
                    <a href="#" className="footer__column-link">
                      Centre d'aide
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer__column-link">
                      Contact
                    </a>
                  </li>
                  <li>
                    <a href="#" className="footer__column-link">
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer__column">
                <h4 className="footer__column-title">Légal</h4>
                <ul className="footer__column-list">
                  <li>
                    <a
                      href="/privacy/index.html"
                      className="footer__column-link"
                    >
                      Conditions d'utilisation
                    </a>
                  </li>
                  <li>
                    <a
                      href="/privacy/index.html"
                      className="footer__column-link"
                    >
                      Politique de confidentialité
                    </a>
                  </li>
                  <li>
                    <a
                      href="/privacy/index.html"
                      className="footer__column-link"
                    >
                      Mentions légales
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="footer__bottom">
            <div className="footer__copyright">
              <p>&copy; 2025 Chiesugu. Tous droits réservés.</p>
              <p>
                Développé avec ❤️ par l'équipe <strong>Djamma Dev</strong>
              </p>
            </div>
            <div className="footer__tech">
              <span>Propulsé par Flutter & React</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
